// RecordingPlayer.tsx
import { useRef, useState, memo } from "react";

interface Props {
  src?: string;         
  cnr?: string;
  hearingDate?: string;
}

const RecordingPlayer = memo(({ src }: Props) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  if (!src) {
    return (
      <div className="w-full flex items-center justify-center bg-black" style={{ height: "100dvh" }}>
        <p className="text-red-400 text-sm">No video available</p>
      </div>
    );
  }

  return (
    <div className="w-full bg-black flex justify-center items-center relative" style={{ height: "100dvh" }}>
      {loading && !error && (
        <div className="absolute flex flex-col items-center gap-3 z-10">
          <div className="w-8 h-8 border-2 border-white border-t-transparent rounded-full animate-spin" />
          <p className="text-white text-sm">Loading video...</p>
        </div>
      )}

      {error && (
        <p className="absolute text-red-400 text-sm z-10">{error}</p>
      )}

      {/*
        Plain <video src> pointed straight at the backend's range-serving
        endpoint. The browser issues its own Range requests for buffering
        and seeking — no blob fetch, no loading the whole file into memory.
      */}
      <video
        ref={videoRef}
        src={src}
        controls
        autoPlay
        preload="metadata"
        controlsList="nodownload"
        disablePictureInPicture
        style={{ width: "100%", height: "100%", objectFit: "contain" }}
        onLoadedData={() => setLoading(false)}
        onError={() => {
          setLoading(false);
          setError("Failed to load video");
        }}
      />
    </div>
  );
});

export default RecordingPlayer;